import { createJSONStorage, persist } from "zustand/middleware";
import { StateCreator, createStore } from "zustand/vanilla";
import AuthenticationProvider, { Credentials, ECommerceConfiguration } from "../core/providers/authentication-provider";
import { apply, defer } from "../core/utils";

interface SessionState {
	name: string;
	isAuthenticated: boolean;
	eCommerceConfiguration: ECommerceConfiguration;
	signin: (credentials: Credentials) => Promise<boolean>;
	signout: () => Promise<void>;
}

const nonAuthenticated = {
	name: "", isAuthenticated: false, eCommerceConfiguration: { mode: "", scriptResources: [] }
};

const store: StateCreator<SessionState> = (set) => ({
	name: "",
	isAuthenticated: false,
	eCommerceConfiguration: { mode: "", scriptResources: [] },
	signin: async (credentials: Credentials) => {
		const authResult = await AuthenticationProvider.signin(credentials);
		if (authResult.isAuthenticated) {
			set({ isAuthenticated: true, name: authResult.username, eCommerceConfiguration: authResult.eCommerceConfiguration });
			return true;
		}
		return false;
	},
	signout: () => {
		return AuthenticationProvider.signout()
			.finally(apply(set, nonAuthenticated))
			.finally(defer(() => window.location.reload(), null));
	}
});

const sessionStore = createStore(persist(
	store,
	{
		name: "user-session",
		storage: createJSONStorage(() => sessionStorage)
	}
));

export default sessionStore;